import { FormattedMessage, useIntl } from "react-intl";

import { Button, Segmented } from "antd";

import { CmtFilterBar } from "@app/components/filters/CmtFilterBar.tsx";
import { CmtSearchFilter } from "@app/components/filters/CmtSearchFilter.tsx";
import { CmtDepartmentFilter } from "@app/components/users/filters/CmtDepartmentFilter.tsx";
import { DEFAULT_USER_STATUS, UserStatusFilter } from "@app/models/User.ts";

interface UserPageFiltersProps {
  status: UserStatusFilter;
  departmentIds: string[];
  search: string | undefined;
  handleSearchChange: (value: string) => void;
  handleDepartmentChange: (departments: string[]) => void;
  handleStatusChange: (status: UserStatusFilter) => void;
  reset: () => void;
}

export function UserPageFilters({
  status,
  departmentIds,
  search,
  handleSearchChange,
  handleDepartmentChange,
  handleStatusChange,
  reset,
}: Readonly<UserPageFiltersProps>) {
  const intl = useIntl();
  const showResetButton =
    status !== DEFAULT_USER_STATUS || departmentIds.length > 0 || !!search;

  return (
    <CmtFilterBar>
      <CmtSearchFilter
        defaultValue={search}
        placeholder={intl.formatMessage({
          id: "table.search_name",
          defaultMessage: "Search by first or last name",
        })}
        onQueryChange={handleSearchChange}
      />
      <CmtDepartmentFilter
        defaultValue={departmentIds}
        onQueryChange={handleDepartmentChange}
      />
      <Segmented<UserStatusFilter>
        value={status}
        onChange={handleStatusChange}
        options={[
          {
            value: "active",
            label: intl.formatMessage({
              id: "users.filter.active",
              defaultMessage: "Active",
            }),
          },
          {
            value: "bench",
            label: intl.formatMessage({
              id: "table.on_bench",
              defaultMessage: "On bench",
            }),
          },
          {
            value: "all",
            label: intl.formatMessage({
              id: "users.filter.all",
              defaultMessage: "All",
            }),
          },
        ]}
      />
      {showResetButton && (
        <Button type="link" onClick={reset}>
          <FormattedMessage
            id="table.reset_filters"
            defaultMessage="Reset filters"
          />
        </Button>
      )}
    </CmtFilterBar>
  );
}
